import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark1"><Path fillRule="evenodd" clipRule="evenodd" d="M20.4788 4.88073L10.1428 20.8276L3.48694 13.1208L5.379 11.4868L9.85714 16.672L18.3809 3.521L20.4788 4.88073Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1;
